<template lang="pug">
.form-group
  label(v-if='fieldLabel')
    | {{fieldLabel}}
    span(v-if='required') &nbsp;*
    div.helptip-wrapper
      span.helptip-icon(v-if='helptipBody' @click='toggleHelp()')
        i(:class='[showHelp ? hideIcon : showIcon]')
      ed-input-tooltip(v-if='helptipBody && showHelp || helptipBody && error'
                       :class='{"error-message": error}'
                       :helptipHeader='helptipHeader'
                       :errorTip='error'
                       :helptipBody='helptipBody'
                      )
  div.form-inline.d-flex.justify-content-between
    slot(name='field1')
    slot(name='field2')
</template>

<script>

export default {
  name: 'ed-field-group',

  props: {
    fieldLabel: String,
    required: Boolean,
    helpText: String,
    helptipHeader: String,
    helptipBody: String,
    error: Boolean
  },

  data () {
    return {
      showHelp: false,
      showIcon: 'fas fa-question-circle',
      hideIcon: 'far fa-times-circle'
    }
  },

  methods: {
    toggleHelp () {
      this.showHelp = !this.showHelp
    }
  }
}
</script>

<style scoped lang='scss'>

div.form-inline {
  div {
    width:48.5%;
  }
}

.helptip-icon {
  &:hover {
    cursor: pointer;
  }
}

.helptip-wrapper {
  display: inline-block;
  position: relative;
}

.dawn-input-tooltip {
  top: -110%;
  width: 2600%;
  left: 230%;
}

</style>



// WEBPACK FOOTER //
// index.vue?632e447c